import {Context, createContext} from 'solid-js'
import {ConfigProviderBehavior} from './ConfigProvider'

export const ConfigContext: Context<ConfigProviderBehavior> = createContext({
    getConfig: () => undefined,
})
